export default function() {
    const lazyLoadingImages = document.querySelectorAll('.lazy-load');
    if (lazyLoadingImages && lazyLoadingImages.length > 0) {
        lazyLoadingImages.forEach(image => {
            if (image.dataset.src) {
                image.src = image.dataset.src;
            }
        });
    }
}